import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { KycDocumentsResponse } from './types/Kyc';

export type GetKycDocumentsPayload = (
  userId: 'me' | number,
  kycUuid: string,
) => Promise<{ data: KycDocumentsResponse }>;

export default (makeCall: MakeCall): GetKycDocumentsPayload => (
  userId,
  kycUuid,
) =>
  makeCall<KycDocumentsResponse>(
    'GET',
    `${APIV2_URL}/user/${userId}/kyc/${kycUuid}/documents`,
  );
